import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

function toPath(url) {
  try {
    return new URL(url).pathname;
  } catch {
    return url?.startsWith("/") ? url : `/${url || ""}`;
  }
}

/** Crawlable breadcrumb trail. Items: [{name, url}] (last item = current page). */
export function Breadcrumbs({ items }) {
  if (!items?.length) return null;
  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="resource-breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {last ? (
                <span className="font-medium text-slate-700">{c.name}</span>
              ) : (
                <Link to={toPath(c.url)} className="hover:text-editorial">{c.name}</Link>
              )}
              {!last && <ChevronRight className="h-3.5 w-3.5 text-slate-300" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
